import type { InputHTMLAttributes, ReactNode } from "react";

export function Notice({ kind, children }: { kind: "ok" | "bad" | "info"; children: ReactNode }) {
  if (!children) return null;
  return (
    <div className={`notice ${kind}`} role={kind === "bad" ? "alert" : "status"}>
      {children}
    </div>
  );
}

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  hint?: string;
}

export function Field({ id, label, hint, ...input }: FieldProps) {
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <input id={id} name={id} aria-describedby={hint ? `${id}-hint` : undefined} {...input} />
      {hint && (
        <span className="hint" id={`${id}-hint`}>
          {hint}
        </span>
      )}
    </div>
  );
}

/** Seitenrahmen wie im Entwurf: Abschnitt mit Innenabstand. */
export function Page({ name, className, children }: { name: string; className?: string; children: ReactNode }) {
  return (
    <section data-page={name} className={className}>
      {children}
    </section>
  );
}

export function PageHead({ eyebrow, title, lead }: { eyebrow: string; title: string; lead?: ReactNode }) {
  return (
    <div className="stack">
      <span className="eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      {lead && <p className="lead">{lead}</p>}
    </div>
  );
}
